"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Model = void 0;
var mobx_1 = require("mobx");
var lodash_1 = require("lodash");
/**
 * The Model class in all its' glory.
 */
var Model = /** @class */ (function () {
    /**
     * If attributes are specified, `set` is called along with the model options.
     */
    function Model(attributes, options) {
        this.set = (0, mobx_1.action)('set', this.set.bind(this));
        // Just in case we have a root store,
        // set it so we don't need the initialize pattern.
        if (options && options.rootStore) {
            ;
            this.rootStore = options.rootStore;
        }
        if (attributes) {
            this.set(attributes, options);
        }
    }
    /**
     * Sets the attributes on the model, optionally calling `parse` first.
     */
    Model.prototype.set = function (attributes, options) {
        if (options) {
            if (options.parse && this.parse) {
                attributes = this.parse(attributes, options);
            }
            if (options.stripUndefined) {
                // Strip out any undefined keys.
                attributes = (0, lodash_1.pickBy)(attributes, function (prop) { return prop !== undefined; });
            }
        }
        Object.assign(this, attributes);
        return this;
    };
    /**
     * Used to convert a raw object to something more meaningful.
     */
    Model.prototype.parse = function (attributes, options) {
        return attributes;
    };
    /**
     * Picks properties and returns them as an object.
     */
    Model.prototype.pick = function (properties) {
        // No guarantees that what is returned actually matches
        // the given TypeScript generic.
        return (0, lodash_1.pick)(this, properties);
    };
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=model.js.map